import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { addCurrentThemeClassToEle, findCourseById, getTimePassedSince, getTimePassedSince2, oldPaymentGatewaysToNewOne } from '@/utils/index'

import { examStatusEnu, examResults, examStatusTextEnu } from '@/pages/dashboard/constants'
import SwipeButton from "@/components/common/swipeButton/SwipeButton"
import ExamReAttemptModal from '@/components/common/examReAttemptModal/examReAttemptModal'
import WhiteLock from '@/assets/icons/whiteLock.png'
import BlackLock from '@/assets/icons/blackLock.png'
import SmallWhiteLock from '@/assets/icons/smallWhiteLock.png'

import BlackTimer from '@/assets/icons/blackTimer.png'
import { useNavigate } from 'react-router-dom';

import './commonSeriesExamCard.css';
import { reattemptExamApiCall, updateExamStatusApiCall } from '@/services/api';
import { toast } from 'sonner';
import EmptyModal from '@/components/common/emptyModal/emptyModal';
import EmptyModalWithBtns from '@/components/common/emptyModal/emptyModalWithBtns';
import { examType } from '@/pages/dashboard/constants';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

import "./examCard.css"
import { themes } from '@/constants/colors_v2';

export default function ExamCard(props: any) {
    const hideThumbnail = Boolean(props.hideThumbnail);
    const watchEmbedCard = Boolean(props.watchEmbedCard);

    /**
     * 1. show swipe button on : unlocked || started
     * 2. lock exam on : locked
     * 3. show pass/fail + When the result will come on : submitted
     * - If failed show re-attempt button
     * 4. show view result button when exam status is : viewResult | hideResult
     * 5. show pass/fail on : hideResult
    */

    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const navigate = useNavigate();


    const { common, dashboard } = useLocalTranslation();
    const [overLayIcon, setOverLayIcon] = useState("")
    const [examStatus, setExamStatus] = useState("")
    const [isActionBtnorModel2Loading, setIsActionBtnorModel2Loading] = useState(false)
    const [isActionBtnOfExamReAttemptModalLoading, setIsActionBtnOfExamReAttemptModalLoading] = useState(false)

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    useEffect(() => {
        // console.log(props.examType, props.exam) // testing
        updateExamStatus()
    }, [props.exam])


    const handleOpenModal = () => {
        setShowModal(true)
    };

    const handleCloseModal = (status: string) => {
        if (status === "ok") {
            const purchaseId = getPurchangeId()

            // debugger
            // -------- START : code of test exam ------------
            if (props.examType === examType.practice) {
                handleReattemptExamApiCall(purchaseId)
                return
            }
            // -------- END : code of test exam ------------



            if (props.exam.examAttempts >= 2) {
                setShowModal(false)
                handlePaymentForReAttempt()
                // console.log("pay then redirect exam")
            } else {
                // console.log("redirect exam ", props.exam.courseId)        
                handleReattemptExamApiCall(purchaseId)
            }
        } else {
            setShowModal(false)
        }
    }

    const handleReattemptExamApiCall = async (purchaseId: any) => {
        setIsActionBtnOfExamReAttemptModalLoading(true)

        let payload: any = {
            purchaseId: purchaseId
        }
        let useThisCourseId = props.exam.courseId
        // debugger
        // -------- START : code of test exam ------------
        if (props.examType === examType.practice) {
            payload = {
                testExamDocId: purchaseId,
                testExamId: props.exam.testExamId
            }
            useThisCourseId = props.exam.testExamId
        }
        // -------- END : code of test exam ------------
        const reattemptExamApiCallStatus = await reattemptExamApiCall(payload, props.examType)
        if (reattemptExamApiCallStatus.status) {
            setIsActionBtnOfExamReAttemptModalLoading(false)
            setShowModal(false)
            navigate('/exam', {
                state: {
                    // courseId: examType === "Test" ? examData.testExamId : examData.courseId,
                    courseId: useThisCourseId,
                    purchaseId: purchaseId,
                    examType: props.examType
                },
            });
        } else {
            toast.error("Issue with re attempting the exam please refresh the page and try again")
            setIsActionBtnOfExamReAttemptModalLoading(false)
            setShowModal(false)
        }
    }

    const updateExamStatus = () => {
        if (props.exam && props.exam.examStatus) {
            setExamStatus(props.exam.examStatus)
            if (props.exam.examStatus === examStatusEnu.locked) {
                setOverLayIcon(WhiteLock)
                return
            }
        }
    }

    const getPurchangeId = () => {
        let purchaseId = props.exam._id
        if (props.exam && props.exam.purchaseId) {
            purchaseId = props.exam.purchaseId
        }
        return purchaseId
    }

    const handleRedirectToResultPage = async () => {
        let purchaseId = getPurchangeId()
        if (purchaseId) {

            // debugger
            // -------- START : code of test exam ------------
            if (props.examType === examType.practice) {
                navigate('/exam-result', {
                    state: {
                        courseId: props.exam.testExamId,
                        purchaseId: purchaseId,
                        examType: examType.practice
                    },
                });
                return
            }
            // -------- END : code of test exam ------------


            const statusToDo = getTimePassedSince2(props.exam.examResultAt)
            if (statusToDo === "show") {
                handleOpenModal2()
                // return // testing
            } else {
                const data = {
                    title: "",
                    content: common.statusText.s1 + " " + statusToDo
                }
                setPopupInfo1(data)
                handleOpenModal1()
            }
        } else {
            toast.error("Purchase Id not found")
        }
    }


    const handleReAttempt = () => {
        // debugger
        if (props.examType === examType.practice) {
            const purchaseId = getPurchangeId()
            handleReattemptExamApiCall(purchaseId)
            return
        }

        handleOpenModal()
    }


    const handleUpdateExamStatusApiCall = async () => {
        setIsActionBtnorModel2Loading(true)
        let purchaseId = getPurchangeId()
        if (purchaseId) {
            const payload = {
                purchaseId: purchaseId,
                examStatus: examStatusEnu.hideResult,
                examStatusText: examStatusTextEnu.hideResult
            }
            const updateExamStatusApiCallStatus: any = await updateExamStatusApiCall(payload)
            if (updateExamStatusApiCallStatus.status) {
                navigate('/exam-result', {
                    state: {
                        courseId: props.exam.courseId,
                        purchaseId: payload.purchaseId,
                    },
                });
            } else {
                toast.error("Issue while opening result page, please refresh the page and try again")
            }
        } else {
            toast.error("Purchase Id not found")
        }
        setIsActionBtnorModel2Loading(false)
        setShowModal2(false)
    }

    const renderResultCon = () => {
        if (examStatus === examStatusEnu.viewResult
            || examStatus === examStatusEnu.submitted
            || examStatus === examStatusEnu.hideResult) {
            let showViewResultBtn = false
            let showReAttemptBtn = false

            if (examStatus === examStatusEnu.viewResult
                || examStatus === examStatusEnu.submitted) {
                showViewResultBtn = true
            }

            if (props.exam.resultDetails && props.exam.resultDetails.result === examResults.failed) {
                showReAttemptBtn = true
            }

            return (
                <div className='flex gap-2 mt-[12px]'>
                    {showReAttemptBtn &&
                        <button
                            disabled={props.isSectionLocked}
                            style={{
                                cursor: props.isSectionLocked ? 'not-allowed' : 'pointer'
                            }}
                            onClick={handleReAttempt}
                            className={`
                            ${showViewResultBtn ? 'w-1/2' : 'w-[100%]'} 
                            cursor-pointer rounded-[5px] bg-[#1573FE] text-[#FFFFFF] text-[14px] py-[4px]`}>
                            {dashboard.evaluateSection.exam.reAttemptBtn}
                        </button>
                    }


                    {showViewResultBtn &&
                        <button
                            disabled={props.isSectionLocked}
                            style={{
                                cursor: props.isSectionLocked ? 'not-allowed' : 'pointer'
                            }}
                            onClick={handleRedirectToResultPage}
                            className={`
                                ${showReAttemptBtn
                                    ?
                                    'examViewResultBtn_50_per w-1/2'
                                    :
                                    'examViewResultBtn_100_per w-[100%]'} 
                                cursor-pointer rounded-[5px] text-[14px] py-[4px]`}
                        >
                            {dashboard.evaluateSection.exam.viewResultBtn}
                        </button>
                    }
                </div>
            )
        }
    }


    const handleSwipe = () => {
        // console.log("handleExam start ", props.exam.courseId)
        let purchaseId = props.exam._id
        if (props.exam && props.exam.purchaseId) {
            purchaseId = props.exam.purchaseId
        }

        let courseId = props.exam.courseId
        // debugger
        // -------- START : code of test exam ------------
        if (props.examType === examType.practice) {
            courseId = props.exam.testExamId
        }
        // -------- END : code of test exam ------------


        navigate('/exam', {
            state: {
                // courseId: examType === "Test" ? examData.testExamId : examData.courseId,
                courseId: courseId,
                purchaseId: purchaseId,
                examType: props.examType
            },
        });
    }

    const accordanceConfig = {
        superLock: false,
        lock: false,
        underReview: false,
        ineligible: false
    }


    const handlePaymentForReAttempt = () => {
        // debugger
        if (props.timelineDetails) {
            const examReAttemptCost = 200
            let gstRate = 18;
            if (props.timelineDetails.orderDetails.paymentGateway === "stripe") {
                gstRate = 9;
            }
            const gst = (examReAttemptCost * gstRate) / 100
            const subTotal = examReAttemptCost - gst

            // debugger
            let useParentDocumentId = props.timelineDetails.orderDetails._id
            if (!props.timelineDetails.orderDetails.isParent && props.timelineDetails.orderDetails.parentDocumentId) {
                useParentDocumentId = props.timelineDetails.orderDetails.parentDocumentId
            }
            const currentCourseObj = findCourseById(props.timelineDetails.orderDetails.courses, props.timelineDetails.courseId)

            const tentativeOrder: any = {
                purchaseId: props.timelineDetails.purchaseId,
                orderType: 'examReattempt',
                paymentStructure: 'full',
                paymentStatus: 'pending',
                totalInstallments: 0,
                paidInstallments: 0,
                isParent: false,
                parentOrderId: props.timelineDetails.orderDetails.orderId,
                parentDocumentId: useParentDocumentId.toString(),
                // parentDocumentId: props.timelineDetails.orderDetails._id.toString(), // useParentDocumentId
                installmentNumber: 0,
                offerDiscountInNumbers: 0,
                offerDiscountInPercentage: 0,
                couponDiscountInNumbers: 0,
                couponDiscountInPercentage: 0,
                gatewayDiscountPercentage: 0,
                gatewayDiscountInNumber: 0,
                originalAmount: Math.round(examReAttemptCost), // total amount
                grandTotal: Math.round(examReAttemptCost), // after discount
                netTotal: Math.round(examReAttemptCost), // same as grand
                GST: Math.round(gst), // 18 % netTotal ... stripe 9%
                subTotal: Math.round(subTotal), // after gst
                continent: props.timelineDetails.orderDetails.courses[0].pricingPlan.prices.continent,
                countryName: props.timelineDetails.orderDetails.courses[0].pricingPlan.prices.countryName,
                currencySymbol: props.timelineDetails.orderDetails.courses[0].pricingPlan.prices.symbol,
                currencyCode: props.timelineDetails.orderDetails.courses[0].pricingPlan.prices.code,
                installmentSchedule: null,
                installmentOption: null,
                course: currentCourseObj, // check : send course OR course
                coursesMnemonic: currentCourseObj.mnemonic
            }

            // console.log('installmentDetails :', tentativeOrder, timelineDetails.orderDetails.paymentGateway)
            const useThisPaymentGateWay = oldPaymentGatewaysToNewOne(props.timelineDetails.orderDetails.paymentGateway)

            navigate('/payment', {
                state: {
                    tentativeOrder: tentativeOrder,
                    paymentGateway:useThisPaymentGateWay,
                },
            });
        } else {
            alert('Issue in payment, please refresh and try again')
        }
    }



    const [showModal1, setShowModal1] = useState(false)
    const [popupInfo1, setPopupInfo1] = useState({})
    const handleOpenModal1 = () => {
        setShowModal1(true)
    };
    const handleCloseModal1 = (status: string) => {
        setShowModal1(false)
    }



    const [showModal2, setShowModal2] = useState(false)
    const handleOpenModal2 = () => {
        setShowModal2(true)
    };
    const handleCloseModal2 = (status: string) => {
        if (status === "close") {
            setShowModal2(false)
            setIsActionBtnorModel2Loading(false)
        } else {
            handleUpdateExamStatusApiCall()
        }
    }


    const addClassAsPerCourse = (className: any) => {
        // props.source :: can be timeline || dashboard
        // console.log(props.source)
        const classNameAsPerTheme = addCurrentThemeClassToEle(currentTheme, className)
        /**
         * Possible class names : 
         * dashboard_dark_theme_examCardMain
         * dashboard_light_theme_examCardMain
         * timeline_dark_theme_examCardMain
         * timeline_light_theme_examCardMain
         * dashboard_dark_theme_examCardMainLocked
         */
        return props.source + "_" + classNameAsPerTheme
    }

    return (
        <div
            style={{
                cursor: overLayIcon === WhiteLock ? 'not-allowed' : 'pointer',
            }}
            className={`examCardMain rounded-[7px] border 
                ${watchEmbedCard ? 'examCardMain_watchEmbed h-auto' : 'h-fit'}
                ${addClassAsPerCourse('examCardMain')}
                ${overLayIcon === WhiteLock ? addClassAsPerCourse('examCardMainLocked') : ''}
                ${hideThumbnail ? 'examCardMain_noThumb' : ''}
            `}
        >

            {!hideThumbnail && (
                <div>
                    <div className="relative examCardMain_01">
                        <img
                            className="w-full h-full object-cover rounded-[7px]"
                            src={props.exam?.examThumbnailUrl}
                            alt={"Exam thumbnail"}
                        />
                        {overLayIcon != "" &&
                            <div>
                                <div className="absolute inset-0 bg-black/30 rounded-[7px]" />
                                <img
                                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[28px]"
                                    src={overLayIcon}
                                    alt="Overlay icon"
                                />
                            </div>
                        }
                    </div>
                </div>
            )}
            <div
                className={[
                    "flex flex-col overflow-hidden examCardMain_02",
                    hideThumbnail ? "examCardMain_02_noThumb" : "pl-[10px] pr-[23px] py-[0px]",
                    watchEmbedCard && hideThumbnail ? "examCardMain_02_watchEmbed" : "justify-center",
                ].join(" ")}
            >
                {hideThumbnail && overLayIcon != "" && (
                    <>
                        <div
                            className="absolute inset-0 rounded-[7px]"
                            style={{
                                backgroundColor:
                                    currentTheme === themes.dark ? "#2C2C2C" : "#0000001A",
                            }}
                            aria-hidden
                        />
                        {!hideThumbnail &&<img
                            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[28px] z-[3]"
                            src={overLayIcon}
                            alt="Overlay icon"
                        />}
                    </>
                )}
                <div className={`w-full overflow-hidden relative ${watchEmbedCard && hideThumbnail ? 'examCardMain_innerWatchEmbed' : ''}`}>
                    <p
                        className={`examTitle_examCard examTitle_examCard_twoLineClamp font-medium ${overLayIcon === WhiteLock ? 'examTitle_examCard_lock' : 'examTitle_examCard_unlock'}`}>
                        {props.exam?.examTitle}
                    </p>

                    {examStatus === examStatusEnu.locked &&
                        <div className='flex items-center mt-[15px]'>
                            <img
                                className='w-[12px] mr-[5px]'
                                src={currentTheme === themes.dark ? SmallWhiteLock : BlackLock}
                                alt='BlackLock' />
                            <p className='lockMsg_examCard font-medium'>{dashboard.evaluateSection.exam.examIsLocked}</p>
                        </div>
                    }


                    {(examStatus == examStatusEnu.unlocked || examStatus == examStatusEnu.started) &&
                        <div className='mt-[15px]'>
                            {/* swuip btn */}
                            <SwipeButton
                                // id={props.exam.examId}
                                id={props.examType === examType.exam ? props.exam.examId : props.exam.testExamId}
                                accordanceConfig={accordanceConfig}
                                status={examStatus}
                                statusText={props.exam.examStatusText}
                                handleExam={handleSwipe}
                                textColor={"var(--black-color)"}
                            />
                        </div>
                    }


                    {examStatus !== examStatusEnu.locked && props.exam.resultDetails && props.exam.resultDetails.result === examResults.passed
                        && props.exam.resultDetails.percentage != null &&
                        <div className='percentage_examCard border !border-[#2BA302] rounded-[5px] text-[#2BA302] bg-[#F5FFF1] w-fit py-[4px] px-[8px] mt-[15px]'>
                            {dashboard.evaluateSection.exam.passed} - {props.exam.resultDetails.percentage}%
                        </div>
                    }


                    {examStatus !== examStatusEnu.locked && props.exam.resultDetails && props.exam.resultDetails.result === examResults.failed
                        && props.exam.resultDetails.percentage != null &&
                        <div className='percentage_examCard border !border-[#FF0D00] rounded-[5px] text-[#FF0D00] bg-[#FFF5F5] w-fit py-[4px] px-[8px] mt-[15px]'>
                            {dashboard.evaluateSection.exam.failed} - {props.exam.resultDetails.percentage}%
                        </div>
                    }


                    {/* {(examStatus == examStatusEnu.submitted && props.exam.examResultAt && getTimePassedSince(props.exam.examResultAt) !== '') &&
                        <div className='flex items-center mt-[8px]'>
                            <img
                                className='w-[16px] mr-[5px]'
                                src={BlackTimer} alt='BlackTimer' />
                            <p className='resultText_examCard'>
                                {dashboard.evaluateSection.exam.whenResultWillCome}{' '}
                                {getTimePassedSince(props.exam.examResultAt)}
                            </p>
                        </div>
                    } */}


                    {renderResultCon()}
                </div>
            </div>



            <ExamReAttemptModal
                show={showModal}
                handleClose={handleCloseModal}
                title={dashboard.evaluateSection.exam.notice}
                examAttempts={props.exam?.examAttempts}
                actionBtnLoading={isActionBtnOfExamReAttemptModalLoading}
            />


            <EmptyModalWithBtns
                show={showModal2}
                handleClose={handleCloseModal2}
                title={""}
                body={common.statusText.s2}
                btn1Text={common.statusText.proceedBtn}
                btn2Text={common.statusText.cancleBtn}
                actionBtnLoading={isActionBtnorModel2Loading}
            />


            <EmptyModal
                show={showModal1}
                handleClose={handleCloseModal1}
                popupInfo={popupInfo1}
            />

        </div >
    );
}
